import React, {FunctionComponent} from 'react';
import cn from 'classnames';
import Button from './Button';

type PrimaryButtonProps = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  onSubmit?: () => void
  short?: boolean
  narrow?: boolean
  className?: string
  disabled?: boolean
  loading?: boolean
  to?: string
  children: React.ReactNode
}

const PrimaryButton: FunctionComponent<PrimaryButtonProps> = ({
  onClick, onSubmit, short, narrow, className, disabled, loading, to, children,
}) =>

  (
    <Button onClick={onClick} short={short} onSubmit={onSubmit} disabled={disabled} loading={loading}
      narrow={narrow} to={to}
      className={cn(
        className,
        {'opacity-40': disabled}, {'hover:bg-blue-hover': !disabled && !loading},
        'border border-transparent ' +
        'text-white bg-blue focus:outline-none focus:border-blue-focus ' +
        'focus:ring-blue active:bg-blue-press',
      )}
    >{children}
    </Button>
  );


export default PrimaryButton;
